import AppDispatcher from "AppDispatcher";
import { MenuDialogConstants } from "../../Constants/MenuDialogConstants.js";
import { EventEmitter } from "events";
import LocalizationStore from "LocalizationStore";
import BaseServiceApi from 'BaseServiceApi';

const CHANGE_EVENT = "change";

let _states = {
    url: "",
    isOpen: false,
};
class WhatsNewStore extends EventEmitter{
    constructor() {
        super();
        this.dispatchToken = AppDispatcher.register(this.dispatcherCallback.bind(this));
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getState() {
        return _states;
    }

    setDialogState(isOpen) {
        _states.isOpen = isOpen;
    }


    dispatcherCallback(payload) {
        const action = payload.action;
        const data = action.data;
        switch (action.actionType) {
            case MenuDialogConstants.ActionTypes.OPEN_WHATS_NEW_DIALOG:
                const version = LocalizationStore.getTranslatedData("_Version", "").replace(/[^\d.]/g,"");
                let result = [];
                result = version.split(".");
                let serverName = "";
                serverName = BaseServiceApi.hostname;
                let pdfURL = "https://{0}/Assets/WhatsNew_Web-{1}.{2}.pdf";
                _states.url = pdfURL.replace("{0}",serverName).replace("{1}", result[0]).replace("{2}", result[1]);
                _states.isOpen = true;
                this.emit(CHANGE_EVENT);
                break;
            default:
                break;
        }
    }
}

const whatsNewStore = new WhatsNewStore();
export default whatsNewStore;
